var map = {
	"./talesup_music_menutheme.aac": 4291,
	"./talesup_sfx_ui_loading_end_v.wav": 450,
	"./talesup_sfx_ui_menu_click_v.wav": 119,
	"./talesup_sfx_ui_menu_close_v.wav": 8658,
	"./talesup_sfx_ui_menu_open_v.wav": 2611,
	"./talesup_sfx_ui_notif_v.wav": 5468,
	"./talesup_sfx_ui_startgame_v.wav": 7555,
	"./talesup_ui_avatar_changer_apparence_couleur_01.aac": 6126,
	"./talesup_ui_avatar_changer_apparence_couleur_02.aac": 2985,
	"./talesup_ui_avatar_changer_apparence_couleur_03.aac": 5695,
	"./talesup_ui_avatar_changer_apparence_vetements_01.aac": 5780,
	"./talesup_ui_avatar_changer_apparence_vetements_02.aac": 3068,
	"./talesup_ui_avatar_changer_apparence_vetements_03.aac": 5555,
	"./talesup_ui_avatar_changer_apparence_vetements_04.aac": 2313,
	"./talesup_ui_bouton_avancer_texte_01.aac": 1066,
	"./talesup_ui_bouton_avancer_texte_02.aac": 9557,
	"./talesup_ui_bouton_avancer_texte_03.aac": 4381,
	"./talesup_ui_bouton_barre_laterale.aac": 6734,
	"./talesup_ui_bouton_credits_fermer.aac": 6555,
	"./talesup_ui_bouton_credits_ouvrir.aac": 1706,
	"./talesup_ui_bouton_general.aac": 9058,
	"./talesup_ui_bouton_ouvrir_histoire_bibliotheque.aac": 2569,
	"./talesup_ui_boutontitlescreen.wav": 4276,
	"./talesup_ui_button_choice_full.wav": 6987,
	"./talesup_ui_button_choice_short.wav": 5183,
	"./talesup_ui_decompte.aac": 8078,
	"./talesup_ui_ecran_debut_partie.aac": 9133,
	"./talesup_ui_jingle_arrivee_dans_app.aac": 9936,
	"./talesup_ui_jingle_debloquer_cosmetique.aac": 5838,
	"./talesup_ui_jingle_debloquer_histoire.aac": 3907,
	"./talesup_ui_jingle_debloquer_tickets.aac": 460,
	"./talesup_ui_jingle_levelup.aac": 4505,
	"./talesup_ui_jingle_ouverture_app.aac": 442,
	"./talesup_ui_loading_end.wav": 9224,
	"./talesup_ui_menu_deroulant.wav": 3090,
	"./talesup_ui_menu_interaction.wav": 4470,
	"./talesup_ui_swipe.wav": 2367,
	"./talesup_ui_swipe_histoires.aac": 4574,
	"./talesup_ui_timer.wav": 986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7190;